<div class="win-notification">
  <div class="win-notification__header">
    <div class="win-notification__badge">
      <svg-icon
        class="win-notification__badge-icon"
        src="assets/icons/games/coinflip.svg"
      />
      <span>Coinflip</span>
    </div>

    <div class="win-notification__info">
      <span class="win-notification__text">You won</span>
      <span class="win-notification__amount">
        <app-balance-icon balance="skins" size="20px" />
        {{ totalValue() | number:'1.2-2' }}
      </span>
    </div>

    <button class="win-notification__close" (click)="onClose()">
      <svg-icon src="assets/icons/ui/cross.svg" />
    </button>
  </div>

  <div class="win-notification__content">
    <app-skins-row
      class="win-notification__skins"
      [skins]="skins()"
      [maxItemLength]="6"
    />

    <button class="button button--style-yellow padding-x-12 h-40" (click)="onAcceptWinnings()">
      Accept Winnings
    </button>
  </div>
</div>
